var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ad-icon-base',_vm._b({attrs:{"iconName":"check"}},'ad-icon-base',_vm.$attrs,false),[_c('path',{attrs:{"d":"M38.5,5.7l-26,26.7L1.5,21.2c-0.4-0.4-0.9-0.4-1.3,0c-0.4,0.4-0.4,0.9,0,1.3l11.5,11.7c0.4,0.4,0.9,0.4,1.3,0\n\tL39.7,7c0.4-0.4,0.4-0.9,0-1.3C39.4,5.4,38.8,5.4,38.5,5.7z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }